export const ArcaplanetSelectedFastMapLocationPin = () => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.4997 4.63672C14.2308 4.63672 6.69031 12.335 6.69031 21.7979C6.69031 31.8583 15.8445 38.0322 21.9018 42.1166L22.9499 42.8273C23.1161 42.9404 23.3079 42.9969 23.4977 42.9969C23.6876 42.9969 23.8794 42.9404 24.0455 42.8273L25.0936 42.1166C31.1509 38.0322 40.3052 31.8583 40.3052 21.7979C40.3091 12.335 32.7686 4.63672 23.4997 4.63672Z"
        fill="#CE3435"
      />
      <path
        d="M28.5194 21.8778C28.3305 21.4184 27.9072 21.1327 27.4146 21.1327L25.1372 21.189L26.5051 17.9897C26.6653 17.6155 26.6278 17.1882 26.4062 16.8486C26.1846 16.5083 25.8108 16.3047 25.4074 16.3047H21.8364C21.1684 16.3047 20.6144 16.7263 20.3976 17.3854L18.3115 22.7622C18.188 23.1347 18.2478 23.5306 18.4757 23.8493C18.7037 24.1679 19.0569 24.3514 19.4466 24.3514L21.6977 24.2983L19.398 31.0607C19.3382 31.2378 19.4068 31.4333 19.5638 31.5323C19.6292 31.5733 19.7017 31.5934 19.775 31.5934C19.8779 31.5934 19.9799 31.5532 20.0572 31.476L28.2611 23.1935C28.6087 22.8418 28.7075 22.3373 28.5194 21.8778Z"
        fill="white"
      />
    </svg>
  )
}
